// extracted by mini-css-extract-plugin
export var attribution = "_9h-4";
export var authorName = "_9h-5";
export var quote = "_9h-3";
export var testimonial = "_9h-2";
export var trustedBy = "_9h-0";
export var trustedByLabel = "_9h-1";